<template>
  <!-- 招标文件列表弹窗 -->
  <div class="preview-dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      title="招标文件列表"
      :close-on-click-modal="false"
      width="688px"
      class="dialog"
      @open="handleOpen"
    >
      <div class="alert-warning m-r-24 m-l-24 m-t-16 m-b-16">
        <a-icon type="info-circle" class="alert-warning-icon" theme="filled" />
        标书预览只作为查看招标文件使用，不作为已参与项目的依据，如需参与，请进入项目进行招标文件购买和下载。
      </div>
      <div class="preview-list">
        <jczh-upload
          upload-mode="resource"
          :resource-before="bidFilePreviewList"
          disabled
          :single-upload="false"
          employee-id="0"
          :signature-api="() => {}"
          :upload-file-api="() => {}"
          :delete-file-api="() => {}"
          :get-group-id-api="() => {}"
          :get-file-list-by-group-id-api="() => {}"
          :get-file-url-by-file-id-api="
            obj => getFileWPSPreviewMes(obj.attachmentId)
          "
          :get-file-w-p-s-preview-mes-api="getFileWPSPreviewMes"
          :file-list-hidden-control="{ hiddenDownloadBtn: true }"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryBidFilePreviewServiceApi } from '@/api/value-added-service'

export default {
  name: 'BidFilePreviewDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    orderId: {
      type: [String, Number],
      default: 0
    }
  },

  data() {
    return {
      bidFilePreviewList: []
    }
  },

  computed: {
    dialogVisible: {
      get() {
        this.getBidFilePreviewList()
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    /**
     * 获取招标文件列表
     */
    getBidFilePreviewList() {
      if (!this.orderId) return
      queryBidFilePreviewServiceApi(this.orderId)
        .then(res => {
          this.bidFilePreviewList = res.data || []
        })
        .catch(err => {
          console.error('获取招标文件列表失败', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    getFileWPSPreviewMes(fileId) {
      return new Promise((resolve, reject) => {
        const file = this.bidFilePreviewList.find(item => item.id === fileId)
        resolve({
          data: { url: file.url, token: file.token, presignedUrl: file.url }
        })
      })
    },

    /**
     * 打开弹窗时的回调
     */
    handleOpen() {
      // 清除文件信息
      this.bidFilePreviewList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-dialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 0;
    }
  }
}

// 标书预览列表
.preview-list {
  padding-bottom: 16px;
  width: 100%;

  ::v-deep .file-list {
    padding: 16px;
    position: relative;
    max-width: 100%;
    vertical-align: top;

    &:not(:last-child) {
      border-bottom: 1px solid $info-fourth-color;
    }

    .preview-item-name {
      font-size: 14px;
      color: $text-color;
      margin-right: 40px;
    }

    .preview-item-button {
      position: absolute;
      right: 24px;
      padding: 4px 0;
    }
  }
}

.alert-warning {
  border-radius: 4px;
  background: #fff9ec;
  border: 1px solid $warning-second-color;
  color: $text-second-color;
  font-size: 12px;
  padding: 8px;

  .alert-warning-icon {
    color: $warning-color;
    margin-right: 4px;
  }
}
</style>
